var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_107_293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_107_293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.625 22C16.625 20.8109 16.9526 19.697 17.5218 18.7433V14.6976H13.4761C11.8704 16.7829 11 19.3245 11 22C11 24.6755 11.8704 27.217 13.4761 29.3024H17.5218V25.2567C16.9526 24.303 16.625 23.1891 16.625 22Z",
    fill: "#FBBD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 28.375L20.1875 31.1875L23 34C25.6756 34 28.217 33.1296 30.3024 31.5239V27.4825H26.261C25.2989 28.0538 24.1804 28.375 23 28.375Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5218 25.2567L13.4761 29.3024C13.794 29.7153 14.1402 30.1107 14.5147 30.4853C16.7812 32.7517 19.7947 34 23 34V28.375C20.6739 28.375 18.6351 27.1225 17.5218 25.2567Z",
    fill: "#31AA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 22C35 21.2699 34.9339 20.5385 34.8035 19.8261L34.698 19.2496H23V24.8746H28.6931C28.1402 25.9743 27.2902 26.8715 26.261 27.4826L30.3024 31.524C30.7153 31.2061 31.1106 30.8599 31.4853 30.4853C33.7518 28.2188 35 25.2053 35 22Z",
    fill: "#3C79E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5078 17.4922L28.005 17.9893L31.9825 14.0119L31.4853 13.5147C29.2188 11.2482 26.2054 10 23 10L20.1875 12.8125L23 15.625C24.7028 15.625 26.3037 16.2881 27.5078 17.4922Z",
    fill: "#CF2D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 15.625V10C19.7947 10 16.7812 11.2482 14.5147 13.5147C14.1401 13.8893 13.7939 14.2847 13.476 14.6976L17.5217 18.7433C18.6351 16.8775 20.6739 15.625 23 15.625Z",
    fill: "#EB4132"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.cfeac54f447ce5b12cee2e61476d0070.svg";
export { ForwardRef as ReactComponent };